import React from 'react';
import { PackPreviewView } from '@/features/packs/preview';

interface PackPreviewPanelProps {
  packId: number;
  versionId?: number;
  showIds?: boolean;
  onOperatorAssignmentChange?: () => void;
}

export const PackPreviewPanel: React.FC<PackPreviewPanelProps> = ({ 
  packId, 
  versionId,
  showIds = false,
  onOperatorAssignmentChange
}) => {
  // If we have a version ID, we're showing a locked version
  // For now, just show the draft preview - version comparison can be added later
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">Pack Preview</h2>
          <p className="text-muted-foreground">
            {versionId 
              ? `Previewing locked version ${versionId}` 
              : 'Previewing current draft'
            }
            {showIds && (
              <span className="ml-2 text-xs font-mono text-muted-foreground">
                pack_id: {packId}
              </span>
            )}
          </p>
        </div>
      </div>
      
      <PackPreviewView 
        packId={packId.toString()} 
        showIds={showIds}
        onOperatorAssignmentChange={onOperatorAssignmentChange}
      />
    </div>
  );
};
